import type { TerminalProfitWithdrawal, CashTransferStatus } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';
import { ICashier, mapGQLCashier } from './cashier';

export interface ITerminalProfitWithdrawal {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
  cashier: ICashier;
}

export interface ITerminalProfitWithdrawalTable {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  cashierUsername: string;
  adminUsername: string;
}

export interface ITerminalProfitWithdrawalQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLTerminalProfitWithdrawal(gql_terminalProfitWithdrawal?: TerminalProfitWithdrawal | null): ITerminalProfitWithdrawal {
  return {
    id: gql_terminalProfitWithdrawal?.id ?? '',
    amount: gql_terminalProfitWithdrawal ? gql_terminalProfitWithdrawal.amount ?? 0 : 0,
    status: gql_terminalProfitWithdrawal ? gql_terminalProfitWithdrawal.status ?? '' : '',

    updatedAt: gql_terminalProfitWithdrawal ? gql_terminalProfitWithdrawal.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_terminalProfitWithdrawal?.admin),
    cashier: mapGQLCashier(gql_terminalProfitWithdrawal?.cashier),
    createdAt: gql_terminalProfitWithdrawal
      ? new Date(gql_terminalProfitWithdrawal.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
